import { useMemo } from "react";

export function useTherapistIdentity(user) {
  const therapistId = useMemo(() => {
    if (!user) return null;
    if (user.user?.therapists?.length > 0) return user.user.therapists[0];
    if (user.user?.therapist) return user.user.therapist;
    if (user.therapist) return user.therapist;
    if (user.user?._id) return user.user._id;
    if (user._id) return user._id;
    return null;
  }, [user]);

  return { therapistId };
}
